module.exports = __webpack_public_path__ + "static/media/med-bldg-blue-windows.0e502325.png";